import React from 'react';
import MessageWithChart from './MessageWithChart';

const ChartDemo: React.FC = () => {
  // Sample CSV data for testing
  const sampleMessage1 = `Here's the data you requested:

Month,Revenue,Costs,Profit
Jan,15000,8000,7000
Feb,18000,9000,9000
Mar,22000,11000,11000
Apr,25000,12000,13000
May,28000,13000,15000
Jun,32000,14000,18000

This shows a steady growth trend over the first half of the year.`;

  const sampleMessage2 = `Temperature readings from the sensors:

Time,Sensor_A,Sensor_B,Sensor_C
00:00,23.5,24.1,22.8
01:00,23.2,23.9,22.5
02:00,22.8,23.6,22.2
03:00,22.5,23.3,21.9
04:00,22.1,22.9,21.6
05:00,21.8,22.6,21.3
06:00,22.2,23.0,21.7
07:00,23.0,23.8,22.4
08:00,24.5,25.2,23.9

All sensors show similar cooling patterns during early morning hours.`;

  const sampleMessage3 = `Regular text message without any CSV data. This should display normally without any chart visualization.`;

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold text-gray-900">Chart Demo</h1>
      
      <div className="space-y-4">
        <div className="bg-white p-4 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-3">Sample 1: Financial Data</h2>
          <MessageWithChart message={sampleMessage1} />
        </div>
        
        <div className="bg-white p-4 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-3">Sample 2: Sensor Data</h2>
          <MessageWithChart message={sampleMessage2} />
        </div>
        
        <div className="bg-white p-4 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-3">Sample 3: Regular Text</h2>
          <MessageWithChart message={sampleMessage3} />
        </div>
      </div>
    </div>
  );
};

export default ChartDemo;